"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ButtonBase = require("../ButtonBase");

var _getComponentStyle = require("../styleHelpers/getComponentStyle");

var _Typography = require("../Typography");

var _useCustomStyles = require("../utils/useCustomStyles");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var getButtonFocusOutlineShadow = function getButtonFocusOutlineShadow(color) {
  return (0, _styledComponents.css)(["box-shadow:0 0 0 ", " ", ";"], (0, _getComponentStyle.getComponentStyle)('button.base.focus.outlineSize'), color);
};

var ButtonPrimary = _styledComponents.default.button.withConfig({
  displayName: "Button__ButtonPrimary",
  componentId: "sc-1y3xxai-0"
})(["", " justify-content:center;", " color:", ";background:", ";border-color:", ";&:focus{", "}&:hover:not(:disabled){background:", ";border-color:", ";}&:active:not(:disabled){color:", ";background:", ";border-color:", ";}", ""], _ButtonBase.buttonBaseStyles, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
}, (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.backgroundColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.borderColor'), getButtonFocusOutlineShadow((0, _getComponentStyle.getComponentStyle)('button.{color}.outlineColor')), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.backgroundColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.borderColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.backgroundColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.borderColor'), function (props) {
  return props.cssStyles;
});

var ButtonSecondary = _styledComponents.default.button.withConfig({
  displayName: "Button__ButtonSecondary",
  componentId: "sc-1y3xxai-1"
})(["", " justify-content:center;", " color:", ";border-color:", ";&:focus{", "}&:hover:not(:disabled){color:", ";border-color:", ";background:", ";}&:active:not(:disabled){color:", ";border-color:", ";background:", ";}", ""], _ButtonBase.buttonBaseStyles, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
}, (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.borderColor'), getButtonFocusOutlineShadow((0, _getComponentStyle.getComponentStyle)('button.{color}.outlineColor')), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.borderColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.backgroundColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.borderColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.backgroundColor'), function (props) {
  return props.cssStyles;
});

var ButtonText = _styledComponents.default.button.withConfig({
  displayName: "Button__ButtonText",
  componentId: "sc-1y3xxai-2"
})(["", " justify-content:center;", " color:", ";&:focus{", "}&:hover:not(:disabled){color:", ";background:", ";}&:active:not(:disabled){color:", ";border-color:", ";background:", ";}", ""], _ButtonBase.buttonBaseStyles, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(["width:100%;"]);
}, (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.color'), getButtonFocusOutlineShadow((0, _getComponentStyle.getComponentStyle)('button.{color}.outlineColor')), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.hover.backgroundColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.color'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.borderColor'), (0, _getComponentStyle.getComponentStyle)('button.{color}.{variant}.active.backgroundColor'), function (props) {
  return props.cssStyles;
});

var IconBox = _styledComponents.default.div.withConfig({
  displayName: "Button__IconBox",
  componentId: "sc-1y3xxai-3"
})(["display:flex;justify-content:center;align-items:center;margin-", ":", ";width:", ";height:", ";& > *{width:", ";height:", ";}", ""], function (props) {
  return props.marginSide;
}, (0, _getComponentStyle.getComponentStyle)('button.base.icon.gap'), (0, _getComponentStyle.getComponentStyle)('button.base.icon.size.{size}'), (0, _getComponentStyle.getComponentStyle)('button.base.icon.size.{size}'), (0, _getComponentStyle.getComponentStyle)('button.base.icon.size.{size}'), (0, _getComponentStyle.getComponentStyle)('button.base.icon.size.{size}'), function (props) {
  return props.cssStyles;
});

var buttonMap = {
  primary: ButtonPrimary,
  primaryInverted: ButtonPrimary,
  secondary: ButtonSecondary,
  secondaryInverted: ButtonSecondary,
  text: ButtonText,
  textInverted: ButtonText
};
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'brand' : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      customStyles = _ref.customStyles,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      props = _objectWithoutProperties(_ref, ["color", "variant", "size", "startIcon", "endIcon", "children", "className", "disabled", "customStyles", "fullWidth"]);

  var InnerButton = buttonMap[variant] || ButtonPrimary;
  var isKnownVariant = Object.keys(buttonMap).indexOf(variant) > -1;
  var getCustomStyles = (0, _useCustomStyles.useCustomStyles)('button.styles', customStyles);
  return /*#__PURE__*/_react.default.createElement(InnerButton, _extends({
    "data-testid": "pbl-button",
    variant: isKnownVariant ? variant : 'primary'
  }, props, {
    ref: ref,
    size: size,
    className: className,
    disabled: disabled,
    color: color,
    fullWidth: fullWidth,
    cssStyles: getCustomStyles(variant)
  }), startIcon && /*#__PURE__*/_react.default.createElement(IconBox, {
    cssStyles: [getCustomStyles('icon'), getCustomStyles('startIcon')],
    marginSide: "right",
    size: size,
    "data-testid": "pbl-button-icon"
  }, startIcon), /*#__PURE__*/_react.default.createElement(_Typography.ButtonTypography, null, children), endIcon && /*#__PURE__*/_react.default.createElement(IconBox, {
    cssStyles: [getCustomStyles('icon'), getCustomStyles('endIcon')],
    marginSide: "left",
    size: size,
    "data-testid": "pbl-button-icon"
  }, endIcon));
});
exports.Button = Button;